export function verif(rows, month, AN) {
  const moisTextuel = ["janv", "févr", "mars", "avr", "mai", "juin", "juil", "août", "sept", "oct", "nov", "déc"];
  const moisStr = moisTextuel[month - 1];
  const anStr = AN.toString().slice(-2);
  const formeDate = `${moisStr}-${anStr}`; 

  var array = [];
  var colDesignation = 0;
  var colCode = 0;
  var colPrix = 0;
  var head = false;
  var test = false;

  for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
    const row = rows[rowIndex];
    const lowercaseRow = row.map(val => val.toString().toLowerCase());

   
    if (!head && lowercaseRow.includes("code") && lowercaseRow.includes("presentation ims") && lowercaseRow.includes(formeDate)) {
      colCode = lowercaseRow.indexOf("code");
      colDesignation = lowercaseRow.indexOf("presentation ims");
      colPrix = lowercaseRow.indexOf(formeDate);
      head = true;
      test = true;
      continue;
    }

    if (!head) continue;

    const code = row[colCode];
    const designation = row[colDesignation];

    if (
      (typeof code === 'string' ) ||
      (typeof code === 'number' && !isNaN(code))
    ) {
      array.push({
        designation: designation,
        idProduit: null,
        code: code,
        valeur: row[colPrix] === undefined ? 0 : row[colPrix],
      });
    }
  }

  return { array: array, test: test };
}






